import {get,post} from "@/utils/request.js"

/* 
	公共页面调用
 */
//获取===总订单详情
export function appUserFindByOrerInfo(data){
	return post('/admin/appCUserorder/appUserFindByOrerInfo',data)
}
//获取===子订单详情
export function appUserFindByBackstageInfo(data){
	return post('/admin/appCUserorder/appUserFindByBackstageInfo',data)
}
//判断订单类型
export function appUserByBackstageOrOrder(data){
	return post('/admin/appCUserorder/appUserByBackstageOrOrder',data)
}
// 订单地址修改接口
export function appCBackstageAndOrderUpAddres(data){
	return post('/app/appCBackstage/appCBackstageAndOrderUpAddres',data)
}
// 查询物流信息
export function findLogistics(data){
	return post('/admin/appCGoods/findLogistics',data)
}

// 查询用户折扣
export function selectUserdiscount(data){
	return post('admin/appCUserorder/selectUserdiscount',data)
}



 
 // 获取评价商品
 export function appCUserorderList(data) {
 	return post('/admin/appCUserorder/appCUserorderList', data)
 }
 // 评价
 export function addAppCComments(data) {
 	return post('/admin/appCComments/addAppCComments', data)
 }
